<template functional>
	<svg xmlns="http://www.w3.org/2000/svg" :width="props.size" :height="props.size" viewBox="0 0 130 130"><path :style="`fill: ${props.color}`" d="M112.93578,34H17.06422a7.00029,7.00029,0,1,1,0-14h95.87156a7.00029,7.00029,0,1,1,0,14ZM120,103a7.03205,7.03205,0,0,0-7.06422-7H17.06422a7.00029,7.00029,0,1,0,0,14h95.87156A7.03205,7.03205,0,0,0,120,103Zm0-38a7.03205,7.03205,0,0,0-7.06422-7H17.06422a7.00029,7.00029,0,1,0,0,14h95.87156A7.03205,7.03205,0,0,0,120,65Z" /></svg>
</template>

<script>
export default {
	name: 'HamburgerIcon',
	props: {
		color: {
			type: String,
			default: '#2a77a6'
		},
		size: {
			type: Number,
			default: 30
		}
	}
};
</script>